module.exports = __webpack_public_path__ + "static/identify-users-2-8d462bd28b2b0581ffd4e0f80132f7bb.png";